import { useFormikContext } from 'formik';
import { parseDate } from '@internationalized/date';

import { maritalStatus } from '@shared/constants/settings';
import { Label } from '@src/design-system/label';
import { FormikCountryField } from '@shared/fields/country-field/formik-country-field';
import { SelectField } from '@shared/fields/select-field';
import { FormikDatePicker } from '@src/shared/fields/formik-date-picker-field';

import type { TUser } from '@shared/types/user';

const EditAdditionalInfo = () => {
  const { setFieldValue, values } = useFormikContext<TUser>();

  return (
    <div>
      <div className='bg-white rounded-xl p-5 mb-5 flex flex-col gap-4'>
        <p className='text-gray-600 font-medium text-sm mb-2'>
          Additional Information
        </p>
        <div className='mb-3'>
          <FormikDatePicker
            name='date_of_birth'
            maxValue={undefined}
            aria-label='date of birth'
            onChange={(newDate) =>
              setFieldValue('date_of_birth', newDate?.toString())
            }
            granularity='day'
            label='Date of Birth'
            value={
              values?.date_of_birth
                ? parseDate(values.date_of_birth)
                : undefined
            }
          />
        </div>
        <div>
          <Label className='mb-3'>Gender</Label>
          <SelectField
            options={[
              { value: 'MALE', label: 'Male' },
              { value: 'FEMALE', label: 'Female' },
            ]}
            selectName='gender'
            selectPlaceholder='Gender'
          />
        </div>
        <div>
          <Label className='mb-3'>Martial Status</Label>
          <SelectField
            options={maritalStatus}
            selectName='marital_status'
            selectPlaceholder='Martial Status'
          />
        </div>
        <div className='mb-3'>
          <Label>Nationality</Label>
          <FormikCountryField selectName={'nationality'} />
        </div>
      </div>
    </div>
  );
};

export default EditAdditionalInfo;
